import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Summary from '../Summary';
import '../Appointment.scss';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Typography, Button } from '@material-ui/core';
import { ProductDetailsDialog } from '../../../Common/Cards/MCTQuoteCard';
import NumberFormat from "react-number-format";
import  CurrencyFormat  from "../../../../Helpers/Formatters/CurrencyFormat";
import AmericoQuoteCard from "../../../../Quoters/Common/Cards/AmericoQuoteCard";

export default function ProductSummary(props) {

  const [isProductDetailsDialogOpen, setIsProductDetailsDialogOpen] = useState(false);

  const productDetailsButton = (productName) => {
    return (
      <Row>
        <Col className="d-flex justify-content-center mb-2 mt-2">
          <Button onClick={() => setIsProductDetailsDialogOpen(true)} color="primary" aria-describedby={productName}>PRODUCT DETAILS</Button>
        </Col>
      </Row>
    );
  }

  const productDetailsOnClick = () => {
    var brochure = props.selectedQuote[0].getBrochure(props.basicInfo.state);
    window.open(brochure.url, '_blank');
  }
  return (
    <Col xs={12} md={6} lg={{ span: 4, offset: 2 }} className={props.hideInMobile ? "hide-class" : ""}>
      {!props.hideInMobile && <h4 className="display-class">Great Selection!</h4>}
      {props.product === "Long Term Care" && (null)}
      {props.product === "Supplemental Insurance" && (
        <Card className="justify-content-center text-center card">
          <img className="mb-2 mx-auto carrier-logo" src={"/product-landing/supp/aflac-logo.png"}
            alt={`${props.carrierName}`} />
          <p>
            <NumberFormat
              className="quote-amount-dollar"
              value={props.premium}
              displayType={'text'}
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
            />
            <span className="quote-amount-mo"> /mo</span>
          </p>
          <Row>
            <Col className="d-flex justify-content-center mb-2 mt-2">
              <Button onClick={() => productDetailsOnClick()} color="primary" aria-describedby={props.product}>PRODUCT DETAILS</Button>
            </Col>
          </Row>
        </Card>
      )}
      {props.product === "Term Life Insurance" && (
        <Card className="justify-content-center text-center card">
          <CardContent>
            <img src={props.logoUrl} alt={`${props.carrierName}`} className="carrier-logo" />
            {props.rating && (
              <Typography color="primary" className="mt-3">{props.rating} Rating</Typography>
            )}

            <p className="coverage">Coverage Amount</p>
            <h2 className="amount">{<CurrencyFormat number={props.coverageAmount} whole/>}</h2>
            <p>
              <NumberFormat
                className="quote-amount-dollar"
                value={props.premium}
                displayType={'text'}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
              />
              <span className="quote-amount-mo"> /mo</span>
            </p>
            {productDetailsButton(props.productName)}
          </CardContent>

          <ProductDetailsDialog
            isOpen={isProductDetailsDialogOpen}
            productDetails={props.productDetails}
            quoteCardProps={props}
            onClose={() => setIsProductDetailsDialogOpen(false)}
          />
        </Card>
      )}
      {props.product === "Loan Protection Life Insurance" && (
        <Card className="justify-content-center text-center card">
          <CardContent>
            <img src={process.env.PUBLIC_URL + '/americo/Americo.png'} alt={'Americo Logo'} className="carrier-logo" />
            <Typography color="primary" className="mt-3">A++ Rating</Typography>

            <p className="coverage">Coverage Amount</p>
            <h2 className="amount">{<CurrencyFormat number={props.coverageAmount} whole/>}</h2>
            <p>
              <NumberFormat
                className="quote-amount-dollar"
                value={props.premium}
                displayType={'text'}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
              />
              <span className="quote-amount-mo"> /mo</span>
            </p>
            <Row>
              <Col className="d-flex justify-content-center mb-2 mt-2">
                <Button onClick={() => setIsProductDetailsDialogOpen(true)} color="primary" aria-describedby={`Americo`}>PRODUCT DETAILS</Button>
              </Col>
            </Row>
          </CardContent>
          <AmericoQuoteCard
            onNext={() => { }}
            logoUrl={props.logoUrl}
            monthlyRate={props.premium}
            show={isProductDetailsDialogOpen}
            hideSelect={props.hideSelect}
            onHide={() => setIsProductDetailsDialogOpen(false)} />
        </Card>
      )}


      <Summary
        title={props.summaryTitle}
        product={props.product}
        coverageAmount={props.coverageAmount}
        carrier={props.carrier}
        termLength={props.termLength}
        premium={props.premium}
        basicInfo={props.basicInfo}
      />
    </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Appointment/AppointmentSteps/ProductSummary.js